import { TidyGuide } from "@/components/pages/TidyGuide";

const TidyGuideView = () => {
    return (
        <TidyGuide></TidyGuide>
    );
}

export default TidyGuideView;